import {
    APP_ROUTES_KEYS,
    APP_ROUTES_TO_URL,
    PRIVATE_ROUTE_QUERY_PARAM,
    PRIVATE_ROUTES_KEYS,
} from 'core/modules/routing/constants';
import {urlToRouteConverter} from 'core/modules/routing/helpers';
import {IQuery, TPrivateRoute, TRouteData, TRouteFn} from 'core/modules/routing/types';
import {useRouter} from 'next/router';
import {useCallback, useMemo} from 'react';

/**
 * Хук для работы с приватными маршрутами личного кабинета
 * @returns Объект с методами для навигации по приватным страницам
 */
export const usePersonalPrivateRoutes = (): TRouteData<TPrivateRoute> => {
    const {push} = useRouter();

    const redirect = useCallback(
        (fn: TRouteFn) => (query?: IQuery) => {
            const url = fn(query);
            push(url);
        },
        [push],
    );

    const urls = useMemo(() => {
        const baseUrl = APP_ROUTES_TO_URL[APP_ROUTES_KEYS.personal];

        // URL для страницы с query параметром
        const createUrlWithQuery = (queryParam: string) => `${baseUrl}/?lk_tabs=${queryParam}`;

        return {
            [APP_ROUTES_KEYS.personal]: () => `${baseUrl}/`,
            [PRIVATE_ROUTES_KEYS.lk]: () => createUrlWithQuery(PRIVATE_ROUTE_QUERY_PARAM[PRIVATE_ROUTES_KEYS.lk]),
            [PRIVATE_ROUTES_KEYS.history]: () =>
                createUrlWithQuery(PRIVATE_ROUTE_QUERY_PARAM[PRIVATE_ROUTES_KEYS.history]),
            [PRIVATE_ROUTES_KEYS.inviteFriend]: () =>
                createUrlWithQuery(PRIVATE_ROUTE_QUERY_PARAM[PRIVATE_ROUTES_KEYS.inviteFriend]),
            [PRIVATE_ROUTES_KEYS.offers]: () =>
                createUrlWithQuery(PRIVATE_ROUTE_QUERY_PARAM[PRIVATE_ROUTES_KEYS.offers]),
            [PRIVATE_ROUTES_KEYS.favorites]: () =>
                createUrlWithQuery(PRIVATE_ROUTE_QUERY_PARAM[PRIVATE_ROUTES_KEYS.favorites]),
            [PRIVATE_ROUTES_KEYS.settings]: () =>
                createUrlWithQuery(PRIVATE_ROUTE_QUERY_PARAM[PRIVATE_ROUTES_KEYS.settings]),
        };
    }, []);

    return useMemo<TRouteData<TPrivateRoute>>(
        () => urlToRouteConverter({section: APP_ROUTES_KEYS.personal, urls, redirect}),
        [urls, redirect],
    );
};
